const UpdatedAvailablePlans = ({ defaultAvailablePlans = [], filterAvailablePlans = [], planSku }) => {

  let newAvailablePlans = []

  // We get every plan updated option_id and option_value plan except the plan with the same sku
  // filterAvailablePlans = filterAvailablePlans.filter(plan => plan.sku !== planSku)

  // We get the current plan with the updated option_id and option_value
  // defaultAvailablePlans = defaultAvailablePlans.find(plan => plan.sku === planSku)

  // Always keep in memory the current plan when we refresh the slider
  // newAvailablePlans[0] = defaultAvailablePlans
  // newAvailablePlans = [...newAvailablePlans, ...filterAvailablePlans]
  newAvailablePlans = [...filterAvailablePlans]

  // filter any undefined plan, sometimes we receive a sku not correctly configured
  // we need to do this to avoid breaking the app
  newAvailablePlans = newAvailablePlans.filter(plan => plan)

  return newAvailablePlans
}

const FormatPrice = (price, locale) => {
  if (locale === 'fr') {
    return price.replace('.', ',')
  } else if (locale === 'en') {
    return price.replace(',', '.')
  } else {
    return price
  }
}

const CalculateMobilePrice = ({optionPrice, currency = '€', locale = 'fr'}) => {
  if (Number.isSafeInteger(optionPrice)) {
    return locale === 'en' ? `${currency}${optionPrice}` : `${optionPrice}${currency}`
  } else {
    optionPrice = optionPrice.toFixed(2)
    optionPrice = FormatPrice(optionPrice, locale)
    return locale === 'en' ? `${currency}${optionPrice}` : `${optionPrice}${currency}`
  }
}

const AddSpaceFr = (productInfo) => productInfo.locale == 'fr' ? ' ' : ''

export {
  UpdatedAvailablePlans,
  FormatPrice,
  CalculateMobilePrice,
  AddSpaceFr
}